module.exports = __webpack_public_path__ + "static/Sketch_Balloon-f2fdbce0a7d40713eaa41681432de98a.png";